import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as FieldTeamDetailActions from './field-team-detail.actions';
import { FieldTeam, RailroadLink } from 'src/shared/api';

export const fieldTeamDetailFeatureKey = 'field-team-detail';

export interface FieldTeamDetailsState extends EntityState<FieldTeam> {
	selectedFieldTeamId?: number;
	error?: any;
	isLoading?: boolean;
	isSaving?: boolean;
	shouldStayOnPage?: boolean;
	railroad?: RailroadLink;
}

export const fieldTeamDetailAdapter: EntityAdapter<FieldTeam> = createEntityAdapter<
	FieldTeam
>();

export interface FieldTeamDetailPartialState {
	readonly [fieldTeamDetailFeatureKey]: FieldTeamDetailsState;
}

export const initialState: FieldTeamDetailsState = fieldTeamDetailAdapter.getInitialState(
	{
		isLoading: true,
		isSaving: false,
		// additional entity state properties
	}
);

const fieldTeamReducer = createReducer(
	initialState,
	on(FieldTeamDetailActions.fieldTeamLoadedFromStore, (state) => ({
		...state,
		isLoading: false,
	})),
	on(FieldTeamDetailActions.saveRequested, (state, { shouldStayOnPage }) => ({
		...state,
		isSaving: true,
		shouldStayOnPage,
	})),
	on(FieldTeamDetailActions.railroadSelected, (state, { railroad }) => ({
		...state,
		railroad,
	})),
	on(FieldTeamDetailActions.newFieldTeamSaved, (state) =>
		fieldTeamDetailAdapter.removeOne(0, state)
	),
	on(FieldTeamDetailActions.newFieldTeamSaved, (state, { fieldTeam }) =>
		fieldTeamDetailAdapter.addOne(fieldTeam, { ...state, isSaving: false })
	),
	on(FieldTeamDetailActions.fieldTeamSaved, (state, { fieldTeam }) =>
		fieldTeamDetailAdapter.updateOne(
			{
				id: fieldTeam.id,
				changes: {
					...fieldTeam,
				},
			},
			{ ...state, isSaving: false }
		)
	),
	on(FieldTeamDetailActions.fieldTeamSelected, (state, { fieldTeamId }) => ({
		...state,
		selectedFieldTeamId: fieldTeamId,
	})),
	on(FieldTeamDetailActions.newFieldTeamStarted, (state) =>
		fieldTeamDetailAdapter.addOne({ id: 0 }, { ...state, isLoading: false })
	),
	on(FieldTeamDetailActions.fieldTeamLoadedFromApi, (state, { fieldTeam }) =>
		fieldTeamDetailAdapter.upsertOne(fieldTeam, {
			...state,
			isLoading: false,
		})
	),
	on(FieldTeamDetailActions.errorSavingFieldTeam, (state, { error }) => ({
		...state,
		error,
		isSaving: false,
	})),
	on(FieldTeamDetailActions.fieldTeamDetailDestroyed, (state) => ({
		...state,
		isLoading: true,
		isLoadingLogo: true,
		payrollType: undefined,
		error: undefined,
	}))
);

export function reducer(
	state: FieldTeamDetailsState | undefined,
	action: Action
) {
	return fieldTeamReducer(state, action);
}
